import { createContext } from "react";

const notesContext=createContext();

export default notesContext;